import React, { Component } from 'react'
import { Dialog, DialogContent } from '@material-ui/core';
import {
    obtenerValoresFiltros,
    obtenerPermisosValorAlt,
    mostrarError,
} from '../../../../global/js/funciones';
import { DetalleDisentimiento, DetalleSolicitud, DetalleDisentimientoTrasladoEPS } from "../Bienestar";
import {
    SESIONES_BIENESTAR,
    FASES_BIENESTAR,
    FICHA_SEGUIMIENTO_BIENESTAR,
    COD_ESTADO_ATENDIDO,
    COD_FICHA_UNICA,
    COD_EQUIDAD_G,
    COD_SOL_REM,
} from "../../helper";
import { BienestarMenu } from "./BienestarMenu";
import AppBarModal from '../../../general/AppBarModal';
import TareasTerminadas from "../../../general/TareasTerminadas";
import emma_w from './../../../../global/imagenes/emma_w.png';
import FormatoSesionesDetalle from '../forms/FormatoSesionesDetalle';
import BienestarFormFormatos from '../forms/BienestarFormFormatos';
import { BIENESTAR_MODAL_PAPER_FLEX } from '../helpers/bienestarDetalleConstants';
import { PERFIL_ADMIN, PERFIL_ADMIN_BIENESTAR, PERFIL_PSICOLOGO } from '../../helper';
import {
    puedeVerContenidoBienestar,
    MENSAJE_SIN_PERMISO_PROFESIONAL,
} from '../helpers/bienestarAccesoPermisos';
import {
    normalizarBienestar,
    normalizarCodigoFicha,
    construirCompletadosPorFase,
    extraerFechaRegistro,
    obtenerFechaUltimaFicha,
    obtenerUltimoEditorFicha,
    obtenerTipoServicioCodigoParaProgreso,
    normalizarPayloadProgreso,
} from '../helpers/bienestarFichaUtils';
import {
    fetchProgresoFichaSeguimiento,
    fetchBienestarDetallePorId,
    fetchEstadosBienestar,
    fetchObservacionesBienestar,
    fetchHistorialEstudiante,
    fetchAdjuntosBienestar,
    fetchAdjuntosFicha,
    fetchSolicitudesBienestar,
    fetchFormulariosCompletadosBienestar,
    fetchDatosBienestarSicuc,
    enviarRemisionConfirmacion,
} from '../services/bienestarDetalleService';
import DialogAccionesCerrarBienestar from './detalle/DialogAccionesCerrarBienestar';
import DetalleEstadosTab from './detalle/DetalleEstadosTab';
import DetalleObservacionesTab from './detalle/DetalleObservacionesTab';
import DetalleHistorialEstudianteTab from './detalle/DetalleHistorialEstudianteTab';
import DetalleAdjuntosTab from './detalle/DetalleAdjuntosTab';
import DetalleFichaSeguimientoTab from './detalle/DetalleFichaSeguimientoTab';
import DetalleRemisionesPendientes from './detalle/DetalleRemisionesPendientes';
import MensajeSinPermiso from './detalle/MensajeSinPermiso';
import BienestarFormatosContenido from './detalle/BienestarFormatosContenido';
import DialogDetalleDisentimiento from './detalle/DialogDetalleDisentimiento';
import DialogMaterialApoyo from './detalle/DialogMaterialApoyo';
import DialogAsignarProfesional from './detalle/DialogAsignarProfesional';


class BienestarDetalle extends Component {
    constructor(props) {
        super(props)
        this.state = {

            // flujo de sesiones
            sesionSeleccionada: null,
            sesionesFormatos: [],
            formulariosCompletadosPorSesion: {}, 

            // flujo de fases
            fasesFormatos: [],
            faseSeleccionada: null,
            moduloSeleccionado: null,
            formulariosCompletadosPorFase: {},

            // flujo de fichas de seguimiento
            fichaSeguimiento: [],
            fichaSeleccionada: null,
            fichasCargando: false,

            // control global
            vistaActual: 'SESIONES',
            bienestar: null,
            tipoServicioActual: null,
            tipoSolicitudActual: null,
            agendamientoData: null, 
            disentimientoData: null,
            disentimientoEpsData: null,
            detalleFormatos: { tipoFormulario: null, sesion: null }, 
            sesionSeleccionadaEnFormatos: null,
            cargando: false,
            detalleDesdeRemision: false,
            formatosCargando: false,
            fasesCargando: false,
            disentimientoCompletado: false,
            disentimientoEpsCompletado: false,
            verDetalleDisentimiento: false,
            verDetalleDisentimientoEps: false,
            formatosReady: false,
            seleccion: '',
            estados: [],
            observaciones: [],
            adjuntos: [],
            historial_estudiante: [],
            remisionesPendientes: [],

            // formularios
            tipoFormularioActual: null,
            modalFormularioFormato: false,
        };
        this.omitirProximaRecargaFicha = false;
        this.remisionAutoOpenDisabled = false;
        this.remisionCheckInFlight = false;
    }


    resetFormatoState = () => {
        this.setState({
            sesionSeleccionada: null,
            sesionSeleccionadaEnFormatos: null,
            faseSeleccionada: null,
            moduloSeleccionado: null,
            tipoFormularioActual: null,
            detalleFormatos: { tipoFormulario: null, sesion: null },
            modalFormularioFormato: false,
            vistaActual: 'SESIONES',
        });
    };


    componentWillUnmount() {
        this.detalleCache.clear();
    }


    puedeVerContenidoSensible = () => {
        let { usuario, esVistaEstudiante, solicitud } = this.props;
        let { bienestar } = this.state;
        const solicitudActual = bienestar || solicitud;
        return puedeVerContenidoBienestar({
            usuario: usuario,
            solicitud: solicitudActual,
            esVistaEstudiante: esVistaEstudiante,
        });
    };


    obtenerProgresoGlobal = (bienestarId, tipoServicioCodigo = '', codigoFichaSecundario = '') =>
        fetchProgresoFichaSeguimiento({
            bienestarId,
            tipoServicioCodigo,
            codigoFichaSecundario,
        });


    obtenerProgresoFicha = async ({ bienestarId, codigoFichaSecundario, ficha }) => {
        let { tipoServicioActual } = this.state;
        const tipoPrimario = obtenerTipoServicioCodigoParaProgreso(ficha, tipoServicioActual?.codigo || '');
        const tipoActual = tipoServicioActual?.codigo || '';
        const intentos = [tipoPrimario, tipoActual, COD_FICHA_UNICA]
            .map((v) => String(v || '').trim())
            .filter(Boolean)
            .filter((v, i, arr) => arr.indexOf(v) === i);
        for (const tipoServicioCodigo of intentos) {
            const progreso = await fetchProgresoFichaSeguimiento({
                bienestarId,
                tipoServicioCodigo,
                codigoFichaSecundario,
            });
            if (progreso) return progreso;
        }
        return null;
    }


    actualizarMetaFichaSeguimientoLocal = (progresoPayload, fichaRef = null) => {
        const progresoNormalizado = normalizarPayloadProgreso(progresoPayload);
        if (!progresoNormalizado) return;
        const codigoObjetivo = normalizarCodigoFicha(
            fichaRef?.secundario?.codigo ||
            this.state?.fichaSeleccionada?.secundario?.codigo ||
            ''
        );
        this.setState((prev) => {
            const lista = Array.isArray(prev.fichaSeguimiento) ? [...prev.fichaSeguimiento] : [];
            if (lista.length === 0) return null;
            let index = -1;
            if (codigoObjetivo) {
                index = lista.findIndex((row) => normalizarCodigoFicha(row?.secundario?.codigo) === codigoObjetivo);
            }
            if (index < 0 && lista.length === 1) {
                index = 0;
            }
            if (index < 0) return null;

            const row = lista[index] || {};
            const progreso = {
                ...(row.progreso || {}),
                ...progresoNormalizado,
            };
            const fila = {
                ...row,
                progreso,
            };
            const ultimoGuardadoPayload = obtenerUltimoEditorFicha({ progreso: progresoNormalizado, adjuntos: [] }, this.props?.usuario);
            const fechaPayload = extraerFechaRegistro(progresoNormalizado);
            fila.ultimo_guardado_por = ultimoGuardadoPayload || obtenerUltimoEditorFicha(fila, this.props?.usuario) || row.ultimo_guardado_por || '';
            fila.fecha_ultima_actualizacion = fechaPayload || obtenerFechaUltimaFicha(fila) || row.fecha_ultima_actualizacion || null;
            lista[index] = fila;
            return { fichaSeguimiento: lista };
        });
    }


    async componentDidUpdate(prevProps, prevState) {
        this.manejarCambioSeleccion(prevState);
        this.manejarCambioModalDetalle(prevProps);
        await this.manejarAperturaModalFormatos(prevProps);
        this.manejarCambioModalConfirmarRemision(prevProps);
        await this.manejarCierreModalFormularioFicha(prevState);
    }


    manejarCambioSeleccion = (prevState) => {
        const { seleccion: seleccionNew, bienestar } = this.state;
        const { bienestar_id, solicitud } = this.props;
        if (seleccionNew === prevState.seleccion || !seleccionNew) return;
        const acciones = {
            'detalle': () => {
                const idToFetch = bienestar_id || (Array.isArray(bienestar) ? bienestar[0]?.id : bienestar?.id);
                if (idToFetch) this.obtenerBienestar(idToFetch);
            },
            'estados': () => this.obtenerEstados(bienestar_id),
            'observaciones': () => this.obtenerObservaciones(bienestar_id),
            'adjuntos': () => this.obtenerAdjuntos(bienestar_id, 2), // 2 = material de apoyo
            'documentos_extras': () => this.obtenerAdjuntos(bienestar_id, 3), // 3 = documentos extras
            'historial_estudiante': () => {
                const usuarioId =
                    bienestar?.[0]?.usuario_registro?.id ??
                    bienestar?.usuario_registro?.id ??
                    solicitud?.usuario_registro?.id;
                if (usuarioId) {
                    this.obtenerHistorialEstudiante(usuarioId);
                } else {
                    this.setState({ historial_estudiante: [] });
                }
            },
            'ficha_seguimiento': () => this.cargarFichaSeguimiento(),
            'documentos_generados': () => this.obtenerAdjuntos(bienestar_id, 1), // 1 = documentos generados
        };
        const accion = acciones[seleccionNew];
        if (accion) accion();
    };


    manejarCambioModalDetalle = (prevProps) => {
        const { modalDetalleBienestar, vistaDetalle } = this.props;
        let { seleccion } = this.state;
        if (prevProps.modalDetalleBienestar === modalDetalleBienestar) return;
        if (!modalDetalleBienestar) return;
        if (seleccion) return;
        this.setState({ seleccion: vistaDetalle || 'detalle' });
    };


    handleDetalleExited = () => {
        if (this.props.modalDetalleBienestar) return;
        this.resetFormatoState();
        this.setState({ seleccion: '', detalleDesdeRemision: false });
    };


    manejarAperturaModalFormatos = async (prevProps) => {
        const { modalFormatosBienestar, bienestar_id } = this.props;
        if (prevProps.modalFormatosBienestar || !modalFormatosBienestar) return;
        this.resetFormatoState();
        this.setState({
            formatosReady: false,
            formatosCargando: true,
            fasesCargando: true,
        });
        try {
            const detalle = await this.fetchBienestarDetalle(bienestar_id);
            const b = normalizarBienestar(detalle);
            this.setState({
                bienestar: detalle,
                tipoServicioActual: b?.tipo_servicio || b?.tipo_servicio_bienestar || null,
                tipoSolicitudActual: b?.tipo_solicitud?.codigo || b?.tipo_solicitud || null,
            });
            await Promise.all([
                this.cargarFormatos(),
                this.cargarFases(),
                this.cargarFormulariosCompletados(),
                this.obtenerEstados(bienestar_id),
            ]);
        } catch (error) {
            console.error("Error en flujo de carga:", error);
        } finally {
            this.setState({ formatosReady: true, formatosCargando: false, fasesCargando: false });
        }
    };


    manejarCambioModalConfirmarRemision = (prevProps) => {
        const { modalConfirmarRemisionBienestar } = this.props;
        if (prevProps.modalConfirmarRemisionBienestar === modalConfirmarRemisionBienestar) return;
        if (modalConfirmarRemisionBienestar) {
            this.verificarRemisionesPendientes();
        } else {
            this.setState({ remisionesPendientes: [] });
        }
    };


    manejarCierreModalFormularioFicha = async (prevState) => {
        const { modalFormularioFormato, seleccion } = this.state;
        const seCerro = prevState.modalFormularioFormato && !modalFormularioFormato;
        if (!seCerro || seleccion !== 'ficha_seguimiento') return;
        if (this.omitirProximaRecargaFicha) {
            this.omitirProximaRecargaFicha = false;
            return;
        }
        await this.cargarFichaSeguimiento();
    };


    async cargarFormatos() {
        this.setState({ formatosCargando: true });
        if (!this.puedeVerContenidoSensible()) {
            this.setState({
                sesionesFormatos: [],
                formatosCargando: false,
            });
            return;
        }
        try {
            const sesiones = await obtenerValoresFiltros([{ llave: 'generica', valor: SESIONES_BIENESTAR }, { llave: 'estado', valor: 1 }]);
            this.setState({ 
                sesionesFormatos: Array.isArray(sesiones) ? sesiones : [], 
                formatosCargando: false ,
            });
        } catch (err) {
            this.setState({ sesionesFormatos: [], formatosCargando: false });
        }
    }
    

    async cargarFases() {
        this.setState({ fasesCargando: true });
        if (!this.puedeVerContenidoSensible()) {
            this.setState({
                fasesFormatos: [],
                fasesCargando: false,
            });
            return;
        }
        try {
            const fases = await obtenerValoresFiltros([{ llave: 'generica', valor: FASES_BIENESTAR }, { llave: 'estado', valor: 1 }]);
            this.setState({
                fasesFormatos: Array.isArray(fases) ? fases : [],
                fasesCargando: false,
            });
        } catch (err) {
            this.setState({ fasesFormatos: [], fasesCargando: false });
        }
    }


    async cargarFichaSeguimiento(progresoPayload = null, fichaRef = null) {
        this.setState({ fichasCargando: true });
        const { tipoServicioActual } = this.state;
        const { bienestar_id } = this.props;
        if (!this.puedeVerContenidoSensible()) {
            this.setState({
                fichaSeguimiento: [],
                fichasCargando: false,
            });
            return;
        }
        if (!tipoServicioActual?.codigo || !bienestar_id) {
            this.setState({ fichaSeguimiento: [], fichasCargando: false });
            return;
        }
        try {
            const fichas = await obtenerPermisosValorAlt([
                        { llave: 'principal__codigo', valor: tipoServicioActual?.codigo },
                        { llave: 'secundario__generica', valor: FICHA_SEGUIMIENTO_BIENESTAR }
                    ]);
            if (!Array.isArray(fichas) || fichas.length === 0) {
                this.setState({ fichaSeguimiento: [], fichasCargando: false });
                return;
            }
            const adjuntos = await fetchAdjuntosFicha(bienestar_id);
            const adjuntosGenerados = adjuntos.filter(adj => adj.tipo_adjunto === 1);
            const tipoServicioGlobal = tipoServicioActual?.codigo || '';
            const codigoFichaSeleccionada = normalizarCodigoFicha(this.state?.fichaSeleccionada?.secundario?.codigo || '');
            const progresoForzado = normalizarPayloadProgreso(progresoPayload);
            const codigoFichaForzada = normalizarCodigoFicha(
                fichaRef?.secundario?.codigo ||
                this.state?.fichaSeleccionada?.secundario?.codigo ||
                ''
            );
            const progresoGlobal = await this.obtenerProgresoGlobal(
                bienestar_id,
                tipoServicioGlobal,
                codigoFichaSeleccionada,
            );
            const fichasConAdjuntos = await Promise.all((Array.isArray(fichas) ? fichas : []).map(async (ficha) => {
                const codigoFichaSecundario = normalizarCodigoFicha(ficha?.secundario?.codigo || '');

                const progresoPorFicha = codigoFichaSecundario
                    ? await this.obtenerProgresoFicha({
                        bienestarId: bienestar_id,
                        codigoFichaSecundario,
                        ficha,
                    })
                    : null;
                const codigoGlobal = normalizarCodigoFicha(
                    progresoGlobal?.codigo_ficha_secundario ||
                    progresoGlobal?.ficha?.secundario?.codigo ||
                    ''
                );
                const aplicaGlobal = Boolean(
                    progresoGlobal && (
                        (codigoGlobal && codigoFichaSecundario && codigoGlobal === codigoFichaSecundario) ||
                        (codigoGlobal === '' && codigoFichaSeleccionada && codigoFichaSeleccionada === codigoFichaSecundario) ||
                        (codigoGlobal === '' && Array.isArray(fichas) && fichas.length === 1)
                    )
                );
                const fechaFicha = extraerFechaRegistro(progresoPorFicha);
                const fechaGlobal = extraerFechaRegistro(progresoGlobal);
                const tsFicha = fechaFicha ? new Date(fechaFicha).getTime() : 0;
                const tsGlobal = fechaGlobal ? new Date(fechaGlobal).getTime() : 0;
                let progreso = (aplicaGlobal && tsGlobal >= tsFicha)
                    ? progresoGlobal
                    : progresoPorFicha;

                const aplicaForzado = Boolean(
                    progresoForzado &&
                    (
                        (codigoFichaForzada && codigoFichaSecundario && codigoFichaSecundario === codigoFichaForzada) ||
                        (!codigoFichaForzada && Array.isArray(fichas) && fichas.length === 1)
                    )
                );
                if (aplicaForzado) {
                    progreso = {
                        ...(progreso || {}),
                        ...progresoForzado,
                    };
                }
                const filaConMeta = {
                    ...ficha,
                    adjuntos: adjuntosGenerados,
                    progreso,
                };
                const ultimoGuardadoForzado = aplicaForzado
                    ? obtenerUltimoEditorFicha({ progreso: progresoForzado, adjuntos: [] }, this.props?.usuario)
                    : '';
                const fechaForzada = aplicaForzado
                    ? extraerFechaRegistro(progresoForzado)
                    : null;
                const ultimoGuardadoPor = ultimoGuardadoForzado || obtenerUltimoEditorFicha(filaConMeta, this.props?.usuario);
                const fechaUltimaActualizacion = fechaForzada || obtenerFechaUltimaFicha(filaConMeta);
                return {
                    ...filaConMeta,
                    ultimo_guardado_por: ultimoGuardadoPor || '',
                    fecha_ultima_actualizacion: fechaUltimaActualizacion || null,
                };
            }));
            this.setState({ 
                fichaSeguimiento: fichasConAdjuntos, 
                fichasCargando: false,
            });
        } catch (err) {
            console.error('Error cargando fichas de seguimiento:', err);
            this.setState({ fichaSeguimiento: [], fichasCargando: false });
        }
    }


    async cargarDetallesFormatos() {
        let { bienestar_id } = this.props;
            try {
                this.setState({ formatosReady: false });
                if (!bienestar_id) return;
                const detalle = await this.fetchBienestarDetalle(bienestar_id);
                const detalleObj = normalizarBienestar(detalle);
                const tipoServicio = detalleObj?.tipo_servicio || detalleObj?.tipo_servicio_bienestar || null;
                const tipoSolicitud = detalleObj?.tipo_solicitud?.codigo || detalleObj?.tipo_solicitud || null;
                const detalleAgendamiento = detalleObj?.detalle_agendamiento || null;
                const agendamientoData = {
                    profesional_asignado: detalleAgendamiento?.profesional_asignado || detalleObj?.profesional_asignado || null,
                    modalidad: detalleAgendamiento?.modalidad || detalleObj?.modalidad || null,
                };
                this.setState({ tipoServicioActual: tipoServicio || null, agendamientoData, tipoSolicitudActual: tipoSolicitud || null });
                await this.cargarFormulariosCompletados();
                this.setState({ formatosReady: true });
            } catch (err) {
                this.setState({ formatosReady: true });
            }
        }


    cargarFormulariosCompletados = async () => {
        let { bienestar_id } = this.props
        try {
            const bienestarId = bienestar_id;
            if (!bienestarId) return;
            const respuestas = await fetchFormulariosCompletadosBienestar(bienestarId);
            if (!respuestas) return;
            const normalizarRespuesta = (resp) =>
                Array.isArray(resp?.results) ? resp.results : Array.isArray(resp) ? resp : [];
            const formulariosMap = {};
            const procesarRegistros = (registros, tipoFormulario) => {
                registros.forEach(r => {
                    const sesionNumero = r.sesion_numero;
                    if (!sesionNumero) return;
                    if (!formulariosMap[sesionNumero]) formulariosMap[sesionNumero] = {};
                    formulariosMap[sesionNumero][tipoFormulario] = true;
                });
            };
            procesarRegistros(normalizarRespuesta(respuestas.asistencias), 'asistencia');
            procesarRegistros(normalizarRespuesta(respuestas.satisfaccion), 'satisfaccion');
            procesarRegistros(normalizarRespuesta(respuestas.consentimientoGeneral), 'consentimientoGeneral');
            procesarRegistros(normalizarRespuesta(respuestas.consentimientoCrisis), 'consentimiento_crisis');
            const disentimientoArr = normalizarRespuesta(respuestas.disentimiento);
            const disentimientoCompletado = disentimientoArr.length > 0;
            const disentimientoEpsArr = normalizarRespuesta(respuestas.disentimientoEps);
            const disentimientoEpsCompletado = disentimientoEpsArr.length > 0;
            const formulariosPorFase = construirCompletadosPorFase(normalizarRespuesta(respuestas.adjuntosGenerados));
            this.setState({
                formulariosCompletadosPorSesion: formulariosMap,
                formulariosCompletadosPorFase: formulariosPorFase,
                disentimientoCompletado,
                disentimientoData: disentimientoCompletado ? disentimientoArr[0] : null,
                disentimientoEpsCompletado,
                disentimientoEpsData: disentimientoEpsCompletado ? disentimientoEpsArr[0] : null,
            });
        } catch (err) {
            console.error('Error cargando formularios completados:', err);
        }
    };


    mapSesionToEstado = (session) => {
        const { estados } = this.state;
        if (!Array.isArray(estados)) return null;
        return estados.find(est => {
            const ses = est?.sesion ?? est?.estado_sesion ?? est?.estado ?? null;
            const sesId = (ses && typeof ses === 'object') ? (ses.id ?? ses.valor ?? ses.valorc ?? ses.codigo ?? null) : ses;
            const sesCodigo = (ses && typeof ses === 'object') ? (ses.codigo ?? ses.valor ?? ses.valorc ?? ses.nombre ?? '') : '';
            const sesNombre = (ses && typeof ses === 'object') ? (ses.nombre ?? '') : '';
            const selectedId = session?.id ?? session?.valor ?? session?.valorc ?? session?.codigo ?? null;
            const selectedCodigo = (session?.codigo ?? session?.valor ?? session?.valorc ?? '').toString().toLowerCase();
            const selectedNombre = (session?.nombre ?? '').toString().toLowerCase();
            if (sesId != null && selectedId != null && String(sesId) === String(selectedId)) return true;
            if (sesCodigo && selectedCodigo && sesCodigo.toString().toLowerCase() === selectedCodigo) return true;
            if (sesNombre && selectedNombre && sesNombre.toString().toLowerCase() === selectedNombre) return true;
            return false;
        }) || null;
    }


    async obtenerBienestar(id) {
        this.setState({ cargando: true });
        const resp = await fetchBienestarDetallePorId(id);
        if (resp) {
            const detalleObj = normalizarBienestar(resp);
            this.setState({
                cargando: false,
                bienestar: resp,
                tipoServicioActual: detalleObj?.tipo_servicio || this.state.tipoServicioActual || null,
            });
            return;
        }
        this.setState({ cargando: false });
    }

    detalleCache = new Map();

    async fetchBienestarDetalle(id) {
        const cached = this.detalleCache.get(id);
        if (cached && (Date.now() - cached.timestamp < 30000)) {
            return cached.data;
        }
        const resp = await fetchBienestarDetallePorId(id);
        if (resp) {
            this.detalleCache.set(id, { data: resp, timestamp: Date.now() });
            return resp;
        }
        return null;
    }


    async obtenerEstados(id) {
        this.setState({ cargando: true });
        const resp = await fetchEstadosBienestar(id);
        if (resp) {
            this.setState({ cargando: false, estados: resp });
        } else {
            this.setState({ cargando: false });
        }
    }


    async obtenerObservaciones(idBienestar) {
        this.setState({ cargando: true });
        const lista = await fetchObservacionesBienestar(idBienestar);
        this.setState({ observaciones: lista, cargando: false });
    }


    async obtenerHistorialEstudiante(idBienestar) {
        this.setState({ cargando: true });
        if (!this.puedeVerContenidoSensible()) {
            this.setState({ historial_estudiante: [], cargando: false });
            return;
        }
        const lista = await fetchHistorialEstudiante(idBienestar);
        this.setState({ historial_estudiante: lista, cargando: false });
    }


    async obtenerAdjuntos(idBienestar, tipoAdjunto = null) {
        this.setState({ cargando: true });
        const requiereValidacion = tipoAdjunto === 1 || tipoAdjunto === 2;
        if (requiereValidacion && !this.puedeVerContenidoSensible()) {
            this.setState({ adjuntos: [], cargando: false });
            return;
        }
        const resp = await fetchAdjuntosBienestar(idBienestar, tipoAdjunto);
        if (resp !== null) {
            this.setState({ adjuntos: resp, cargando: false });
        } else {
            this.setState({ cargando: false });
        }
    }


    obtenerSolicitudes = (filtros = []) => fetchSolicitudesBienestar(filtros);


    async verificarRemisionesPendientes() {
        let { usuario, mostrarModalConfirmarRemisionBienestar, modalConfirmarRemisionBienestar } = this.props;
        if (this.remisionAutoOpenDisabled || this.remisionCheckInFlight) return;
        this.remisionCheckInFlight = true;
        try {
            const usuarioId = usuario?.id;
            if (!usuarioId) {
                this.setState({ remisionesPendientes: [] });
                return;
            }
            const periodoResp = await obtenerValoresFiltros([{ llave: 'codigo', valor: 'Per_Bienestar' }]);
            const periodoActivo = Array.isArray(periodoResp) && periodoResp.length > 0 ? periodoResp[0].nombre : '';
            if (!periodoActivo) {
                this.setState({ remisionesPendientes: [] });
                return;
            }
            const filtros = [
                { llave: 'remitente_confirmacion', valor: '0' },
                { llave: 'tipo_solicitud__codigo', valor: COD_SOL_REM },
                { llave: 'periodo', valor: periodoActivo }
            ];
            const pendientesRaw = await this.obtenerSolicitudes(filtros);
            if (!Array.isArray(pendientesRaw)) {
                this.setState({ remisionesPendientes: [] });
                return;
            }
            const candidatos = pendientesRaw.filter(p => {
                const tipoCodigo = p?.tipo_solicitud?.codigo ?? p?.tipo_solicitud ?? '';
                const ownerId = p?.usuario_registro?.id ?? p?.usuario_registro;
                return String(tipoCodigo) === COD_SOL_REM && ownerId == usuarioId;
            });
            const confirmados = [];
            const porVerificar = [];
            candidatos.forEach(p => {
                const rc = p?.remitente_confirmacion;
                if (String(rc) === '0') {
                    confirmados.push(p);
                } else if (rc === undefined || rc === null || rc === '') {
                    porVerificar.push(p);
                }
            });
            if (porVerificar.length > 0) {
                const detallesPromises = porVerificar.map(p => this.fetchBienestarDetalle(p.id));
                const detalles = await Promise.all(detallesPromises);
                detalles.forEach((detalle, idx) => {
                    const detalleObj = normalizarBienestar(detalle);
                    if (String(detalleObj?.remitente_confirmacion) === '0') {
                        confirmados.push(porVerificar[idx]);
                    }
                });
            }
            this.setState({ remisionesPendientes: confirmados });
            if (
                confirmados.length > 0 &&
                !modalConfirmarRemisionBienestar &&
                typeof mostrarModalConfirmarRemisionBienestar === 'function'
            ) {
                mostrarModalConfirmarRemisionBienestar(true);
            }
        } catch (err) {
            this.setState({ remisionesPendientes: [] });
        } finally {
            this.remisionCheckInFlight = false;
        }
    }


    handleRemisionAction = async (pk, accion) => {
        let { 
            mostrarModalConfirmarRemisionBienestar, 
            modalDetalleBienestar, 
            recargarSolicitudes, 
            actualizarMensaje,
            bienestar_id,
        } = this.props;
        let { remisionesPendientes } = this.state;
        try {
            this.setState({ cargando: true });
            const { ok, resp } = await enviarRemisionConfirmacion(pk, accion);
            if (ok) {
                await this.verificarRemisionesPendientes();
                if (typeof mostrarModalConfirmarRemisionBienestar === 'function' && (!remisionesPendientes || remisionesPendientes.length === 0)) {
                    mostrarModalConfirmarRemisionBienestar(false);
                }
                if (modalDetalleBienestar) {
                    this.obtenerBienestar(bienestar_id);
                }
                try {
                    if (typeof recargarSolicitudes === 'function') {
                        recargarSolicitudes();
                    }
                } catch (e) {
                    console.error('handleRemisionAction: error llamando recargarSolicitudes', e);
                }
                const soloRegistrada = resp && resp.estados_actualizados === false;
                actualizarMensaje({
                    titulo: resp?.mensaje || 'Acción realizada',
                    tipo: soloRegistrada ? 'info' : 'success',
                    mostrar: true,
                    tiempo: soloRegistrada ? 6000 : 4000,
                });
            } else {
                const titulo = resp?.titulo || mostrarError(resp) || 'No se pudo actualizar la confirmación.';
                actualizarMensaje({ titulo, tipo: 'error', mostrar: true, tiempo: 4000 });
            }
            this.setState({ cargando: false });
        } catch (err) {
            this.setState({ cargando: false });
            actualizarMensaje({ titulo: 'Error procesando la remisión', tipo: 'error', mostrar: true, tiempo: 4000 });
        }
    }


    pintarDetalleRemision = async (id) => {
        let { mostrarModalDetalleBienestar } = this.props;
        try {
            this.setState({ cargando: true });
            const detalle = await this.fetchBienestarDetalle(id);
            this.setState({ bienestar: detalle || null, seleccion: 'detalle', cargando: false, detalleDesdeRemision: true });
            if (typeof mostrarModalDetalleBienestar === 'function') {
                mostrarModalDetalleBienestar(true);
            }
        } catch (err) {
            this.setState({ cargando: false });
            }
        }


    handleSeleccionarFichaSeguimiento = (row) => {
        this.setState({
            modalFormularioFormato: true,
            tipoFormularioActual: 'ficha_seguimiento',
            fichaSeleccionada: row,
            sesionSeleccionada: null,
            faseSeleccionada: null,
        });
    };


    pintar = () => {
        const {
            seleccion,
            cargando,
            estados,
            observaciones,
            adjuntos,
            historial_estudiante,
            fichaSeguimiento,
            fichasCargando,
            bienestar,
        } = this.state;
        const { usuario, transferirSolicitud } = this.props;
        if (cargando) return <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" />;
        const esVistaAdjuntos =
            seleccion === 'adjuntos' ||
            seleccion === 'documentos_extras' ||
            seleccion === 'documentos_generados';
        const SECCIONES_SENSIBLES = new Set([
            'adjuntos',                  // material de apoyo
            'documentos_generados',
            'historial_estudiante',
            'ficha_seguimiento',
        ]);
        const requiereValidacion = SECCIONES_SENSIBLES.has(seleccion);
        if (requiereValidacion && !this.puedeVerContenidoSensible()) {
            return <MensajeSinPermiso mensaje={MENSAJE_SIN_PERMISO_PROFESIONAL} />;
        }
        const detalleObj = bienestar ? normalizarBienestar(bienestar) : null;
        return (
            <div>
                {seleccion === 'detalle' && detalleObj && <DetalleSolicitud bienestar={detalleObj} />}
                {seleccion === 'estados' && <DetalleEstadosTab estados={estados} />}
                {seleccion === 'observaciones' && <DetalleObservacionesTab observaciones={observaciones} />}
                {esVistaAdjuntos && (
                    <DetalleAdjuntosTab
                        adjuntos={adjuntos}
                        seleccion={seleccion}
                    />
                )}
                {seleccion === 'historial_estudiante' && (
                    <DetalleHistorialEstudianteTab
                        historial={historial_estudiante}
                        transferirSolicitud={transferirSolicitud}
                        abrirDetalleRemision={this.pintarDetalleRemision}
                    />
                )}
                {seleccion === 'ficha_seguimiento' && (
                    <DetalleFichaSeguimientoTab
                        fichas={fichaSeguimiento}
                        cargando={fichasCargando}
                        usuarioActual={usuario}
                        onSeleccionarFicha={this.handleSeleccionarFichaSeguimiento}
                    />
                )}
            </div>
        );
    }


    handleVerDetalle = (tipoFormulario, sesion) => {
        let { mostrarModalFormatosBienestar, mostrarModalDetalleBienestarFormatos } = this.props;
        this.setState({
            detalleFormatos: { tipoFormulario, sesion },
            sesionSeleccionadaEnFormatos: sesion
        }, () => {
            if (typeof mostrarModalFormatosBienestar === 'function') {
                mostrarModalFormatosBienestar(false);
            }
            if (typeof mostrarModalDetalleBienestarFormatos === 'function') {
                mostrarModalDetalleBienestarFormatos(true);
            }
        });
    };


    handleModuleSelect = (key, data, origen = 'SESIONES') => {
        if (!this.puedeVerContenidoSensible()) return;
        const baseState = {
            vistaActual: origen,
            tipoFormularioActual: key,
            modalFormularioFormato: true,
            sesionSeleccionada: null,
            faseSeleccionada: null,
            fichaSeleccionada: null
        };
        if (origen === 'FASES') {
            baseState.faseSeleccionada = data?.fase || null;
            baseState.moduloSeleccionado = data?.modulo || null;
        } else if (origen === 'FICHA_SEGUIMIENTO') {
            baseState.fichaSeleccionada = data;
        } else {
            baseState.sesionSeleccionada = data;
        }
        this.setState(baseState);
    };


    handleModuleSelectSesion = (key, data) => this.handleModuleSelect(key, data, 'SESIONES');
    handleModuleSelectFase = (key, data) => this.handleModuleSelect(key, data, 'FASES');
    handleAbrirDisentimiento = () => this.setState({ modalFormularioFormato: true, tipoFormularioActual: 'disentimiento' });
    handleAbrirDisentimientoEps = () => this.setState({ modalFormularioFormato: true, tipoFormularioActual: 'disentimiento_traslado_eps' });
    handleVerDisentimiento = () => this.setState({ verDetalleDisentimiento: true });
    handleVerDisentimientoEps = () => this.setState({ verDetalleDisentimientoEps: true });
    handleCerrarDisentimiento = () => this.setState({ verDetalleDisentimiento: false });
    handleCerrarDisentimientoEps = () => this.setState({ verDetalleDisentimientoEps: false });
    handleCerrarMaterialApoyo = () => this.props.mostrarModalMaterialApoyoBienestar(false);
    handleCerrarAsignarProfesional = () => this.props.mostrarModalAsignarProfesionalBienestar(false);
    handleCerrarConfirmarRemision = () => {
        this.remisionAutoOpenDisabled = true;
        this.props.mostrarModalConfirmarRemisionBienestar(false);
    };
    handleCerrarDetalleBienestar = () => {
        if (typeof this.props.mostrarModalDetalleBienestar === 'function') {
            this.props.mostrarModalDetalleBienestar(false);
        }
    };
    handleProfesionalAsignado = () => {
        const id = this.props.bienestar_id || this.props.solicitud?.id;
        if (id) this.obtenerBienestar(id);
        if (typeof this.props.recargarSolicitudes === 'function') {
            try { this.props.recargarSolicitudes(); } catch (_e) { /* noop */ }
        }
    };

    render() {
        const { cargando,
            bienestar, 
            seleccion,
            fasesFormatos,
            formulariosCompletadosPorFase,
            formatosCargando,
            sesionSeleccionadaEnFormatos,
            tipoServicioActual,
            sesionesFormatos,
            formulariosCompletadosPorSesion,
            disentimientoCompletado,
            disentimientoEpsCompletado,
            formatosReady,
            detalleDesdeRemision,
            detalleFormatos,
            verDetalleDisentimiento,
            verDetalleDisentimientoEps,
            disentimientoData,
            disentimientoEpsData,
            modalFormularioFormato,
            sesionSeleccionada,
            faseSeleccionada,
            tipoFormularioActual,
            agendamientoData,
            tipoSolicitudActual,
            fichaSeleccionada,
            moduloSeleccionado,
        } = this.state;

        const { modalDetalleBienestar,
                modalFormatosBienestar, 
                modalMaterialApoyoBienestar, 
                modalAsignarProfesionalBienestar,
                modalConfirmarRemisionBienestar, 
                modalDetalleBienestarFormatos, 
                mostrarModalConfirmarRemisionBienestar, 
                mostrarModalDetalleBienestar, 
                mostrarModalFormatosBienestar, 
                mostrarModalDetalleBienestarFormatos, 
                modoLectura,
                estadoActualProp, 
                solicitud,
                id_estado_actual,
                bienestar_id,
                usuario,
                actualizarMensaje,
                esVistaEstudiante,
            } = this.props;

        const tipoServicio = solicitud?.tipo_servicio;
        const estadoActual = solicitud?.estado_actual?.codigo;
        const perfil_usuario = usuario?.perfil?.codigo;
        const esEquidadGenero = tipoServicio?.codigo === COD_EQUIDAD_G && estadoActual === COD_ESTADO_ATENDIDO;
        const noEstudiante = perfil_usuario && (
            perfil_usuario === PERFIL_ADMIN
            || perfil_usuario === PERFIL_ADMIN_BIENESTAR
            || perfil_usuario === PERFIL_PSICOLOGO
        );
        const estadoActualFormatos =
            estadoActualProp ||
            solicitud?.estado_actual ||
            (Array.isArray(bienestar) ? bienestar[0]?.estado_actual : bienestar?.estado_actual) ||
            null;
        const codigoEstadoFormatos = estadoActualFormatos?.codigo || id_estado_actual || null;
        const codigoServicioActualFormatos = tipoServicioActual?.codigo || tipoServicio?.codigo || null;
        return (
            <div>

                {/* modal de detalle bienestar */}
                <Dialog
                    open={modalDetalleBienestar}
                    maxWidth={noEstudiante ? 'md' : 'sm'}
                    fullWidth
                    scroll="paper"
                    onClose={this.handleCerrarDetalleBienestar}
                    PaperProps={{ style: BIENESTAR_MODAL_PAPER_FLEX }}
                    TransitionProps={{ onExited: this.handleDetalleExited }}
                >
                    <AppBarModal titulo='¡ Detalle Proceso !' mostrarModal={mostrarModalDetalleBienestar} titulo_accion='' />
                    <div style={{ flexShrink: 0, position: 'relative', backgroundColor: '#fff' }}>
                        <BienestarMenu
                            sele={seleccion}
                            seleccionar={seleccion => this.setState({ seleccion })}
                            onlyDetalle={detalleDesdeRemision}
                            estadoActual={estadoActualProp || (bienestar && (Array.isArray(bienestar) ? bienestar[0]?.estado_actual : bienestar?.estado_actual))}
                            esEquidadGenero={esEquidadGenero}
                            perfil={usuario?.perfil?.codigo}
                        />
                    </div>
                    <DialogContent
                        style={{
                            flex: '1 1 auto',
                            minHeight: 0,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            padding: 0,
                            WebkitOverflowScrolling: 'touch',
                        }}
                    >
                        {cargando ? (
                            <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />
                        ) : (
                            this.pintar()
                        )}
                    </DialogContent>
                    <DialogAccionesCerrarBienestar onClick={this.handleCerrarDetalleBienestar} />
                </Dialog>


                {/* modal formatos bienestar */}
                <Dialog
                    open={modalFormatosBienestar}
                    maxWidth="lg"
                    fullWidth={false}
                    scroll="paper"
                    onClose={() => { this.resetFormatoState(); mostrarModalFormatosBienestar(false); }}
                    PaperProps={{
                        style: {
                            ...BIENESTAR_MODAL_PAPER_FLEX,
                            width: 'min(920px, calc(100vw - 16px))',
                            maxWidth: 920,
                        },
                    }}
                >
                    <AppBarModal titulo='Formatos' mostrarModal={mostrarModalFormatosBienestar} titulo_accion='' />
                    <DialogContent
                        style={{
                            flex: '1 1 auto',
                            minHeight: 0,
                            width: '100%',
                            maxWidth: 920,
                            padding: 0,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'stretch',
                        }}
                    >
                    <div
                        style={{
                            flex: 1,
                            minHeight: 0,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            WebkitOverflowScrolling: 'touch',
                        }}
                    >
                    <div style={{ padding: 12, width: '100%', boxSizing: 'border-box', minHeight: 420 }}>
                        <BienestarFormatosContenido
                            formatosReady={formatosReady}
                            formatosCargando={formatosCargando}
                            codigoEstado={codigoEstadoFormatos}
                            codigoServicioActual={codigoServicioActualFormatos}
                            esEquidadGenero={esEquidadGenero}
                            esVistaEstudiante={esVistaEstudiante}
                            modoLectura={modoLectura}
                            puedeVerContenido={this.puedeVerContenidoSensible()}
                            disentimientoCompletado={disentimientoCompletado}
                            disentimientoEpsCompletado={disentimientoEpsCompletado}
                            fasesFormatos={fasesFormatos}
                            formulariosCompletadosPorFase={formulariosCompletadosPorFase}
                            sesionesFormatos={sesionesFormatos}
                            formulariosCompletadosPorSesion={formulariosCompletadosPorSesion}
                            sesionSeleccionadaEnFormatos={sesionSeleccionadaEnFormatos}
                            tipoServicioActual={tipoServicioActual}
                            onAbrirDisentimiento={this.handleAbrirDisentimiento}
                            onAbrirDisentimientoEps={this.handleAbrirDisentimientoEps}
                            onVerDisentimiento={this.handleVerDisentimiento}
                            onVerDisentimientoEps={this.handleVerDisentimientoEps}
                            onVerDetalle={this.handleVerDetalle}
                            onModuleSelectSesion={this.handleModuleSelectSesion}
                            onModuleSelectFase={this.handleModuleSelectFase}
                        />
                    </div>
                    </div>
                    </DialogContent>
                    <DialogAccionesCerrarBienestar
                        onClick={() => {
                            this.setState({ sesionSeleccionadaEnFormatos: null });
                            this.resetFormatoState();
                            mostrarModalFormatosBienestar(false);
                        }}
                    />
                </Dialog>


                <DialogMaterialApoyo
                    open={modalMaterialApoyoBienestar}
                    cargando={cargando}
                    puedeVerContenido={this.puedeVerContenidoSensible()}
                    onClose={this.handleCerrarMaterialApoyo}
                />

                <DialogAsignarProfesional
                    open={modalAsignarProfesionalBienestar}
                    solicitud={solicitud}
                    bienestarId={bienestar_id || solicitud?.id}
                    onClose={this.handleCerrarAsignarProfesional}
                    onAssigned={this.handleProfesionalAsignado}
                    actualizarMensaje={actualizarMensaje}
                />

                {/* modal confirmacion remitente */}
                <Dialog open={modalConfirmarRemisionBienestar} maxWidth='sm' fullWidth scroll="paper" onClose={this.handleCerrarConfirmarRemision} PaperProps={{ style: BIENESTAR_MODAL_PAPER_FLEX }}>
                    <AppBarModal titulo='Confirmación de Remisión' mostrarModal={mostrarModalConfirmarRemisionBienestar} titulo_accion='' />
                    <DialogContent style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', padding: 0 }}>
                        {cargando
                            ? <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />
                            : (
                                <DetalleRemisionesPendientes
                                    remisiones={this.state.remisionesPendientes}
                                    onVerDetalle={this.pintarDetalleRemision}
                                    onAccion={this.handleRemisionAction}
                                />
                            )}
                    </DialogContent>
                    <DialogAccionesCerrarBienestar onClick={this.handleCerrarConfirmarRemision} />
                </Dialog>


                {/* modal detalle formatos desde administrador con tabla */}
                {modalDetalleBienestarFormatos && (
                    <Dialog
                        open={modalDetalleBienestarFormatos}
                        maxWidth='sm'
                        fullWidth
                        scroll="paper"
                        onClose={() => mostrarModalDetalleBienestarFormatos(false)}
                        PaperProps={{ style: BIENESTAR_MODAL_PAPER_FLEX }}
                    >
                        <AppBarModal 
                            titulo={`Detalle - ${detalleFormatos?.tipoFormulario === 'consentimiento_crisis' ? 'Consentimiento Crisis' : (detalleFormatos?.tipoFormulario?.charAt(0).toUpperCase() || '') + (detalleFormatos?.tipoFormulario?.slice(1) || '')}`} 
                            mostrarModal={mostrarModalDetalleBienestarFormatos} 
                            titulo_accion='' 
                        />
                        <DialogContent style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', padding: 0 }}>
                            {detalleFormatos?.tipoFormulario && detalleFormatos?.sesion && (
                                <FormatoSesionesDetalle
                                    key={`admin-detalle-${detalleFormatos.tipoFormulario}-${detalleFormatos.sesion?.id || 'nosesion'}`}
                                    bienestar_id={bienestar_id}
                                    tipoFormularioInicial={detalleFormatos.tipoFormulario}
                                    sesionInicial={detalleFormatos.sesion}
                                    usarTablaDetalleSolicitud={true}
                                    ocultarHeaderEnDetalle={true}
                                    onVolverAtras={() => {
                                        mostrarModalDetalleBienestarFormatos(false);
                                        if (typeof mostrarModalFormatosBienestar === 'function') {
                                            mostrarModalFormatosBienestar(true);
                                        }
                                    }}
                                />
                            )}
                        </DialogContent>
                        <DialogAccionesCerrarBienestar
                            onClick={() => {
                                this.setState({ detalleFormatos: { tipoFormulario: null, sesion: null } });
                                mostrarModalDetalleBienestarFormatos(false);
                                if (typeof mostrarModalFormatosBienestar === 'function') {
                                    mostrarModalFormatosBienestar(true);
                                }
                            }}
                        />
                    </Dialog>
                )}


                <DialogDetalleDisentimiento
                    open={verDetalleDisentimiento && disentimientoCompletado}
                    titulo="Detalle Disentimiento Informado"
                    onClose={this.handleCerrarDisentimiento}
                    componenteDetalle={DetalleDisentimiento}
                    datos={disentimientoData}
                />

                <DialogDetalleDisentimiento
                    open={verDetalleDisentimientoEps && disentimientoEpsCompletado}
                    titulo="Detalle Disentimiento Traslado EPS"
                    onClose={this.handleCerrarDisentimientoEps}
                    componenteDetalle={DetalleDisentimientoTrasladoEPS}
                    datos={disentimientoEpsData}
                />


                {/* formulario formatos*/}
                <BienestarFormFormatos
                    modalOpen={modalFormularioFormato}
                    mostrarModal={(val) => this.setState({ modalFormularioFormato: val })}
                    bienestar_id={bienestar_id}
                    sesion={sesionSeleccionada}
                    fase={faseSeleccionada}
                    moduloSeleccionado={moduloSeleccionado}
                    tipoServicio={tipoServicioActual}
                    tipoFormulario={tipoFormularioActual}
                    actualizarMensaje={actualizarMensaje}
                    agendamientoData={agendamientoData}
                    tipoSolicitud={tipoSolicitudActual}
                    solicitud={solicitud}
                    estadoActual={solicitud?.estado_actual}
                    fichaSeleccionada={fichaSeleccionada}
                    modoLectura={modoLectura}
                    esVistaEstudiante={esVistaEstudiante}
                    onSuccess={async (payload) => {
                        if (tipoFormularioActual === 'ficha_seguimiento') {
                            this.omitirProximaRecargaFicha = true;
                            this.actualizarMetaFichaSeguimientoLocal(payload, fichaSeleccionada);
                        }
                        await this.cargarFormulariosCompletados();
                        await this.cargarFichaSeguimiento(payload, fichaSeleccionada);
                    }}
                />
            </div>
        );
    }
}

BienestarDetalle.defaultProps = {
    modoLectura: false,
    esVistaEstudiante: false,
};

export default BienestarDetalle